// extracted by mini-css-extract-plugin
export default {"sort":"DR-z","sortSelect":"ER-z","disabled":"FR-z"};